import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { RosterShort, RosterShortResponse } from "~types/rosterShort";

const useFetchSeasonRosterShort = () => {
  const request = useApi();
  const { organizationId, sport, seasonId } = useParams();

  const url = `${sport}/o/${organizationId}/seasons/${seasonId}/roster/short`;

  return useQuery<RosterShort[]>({
    queryKey: ["seasonRosterShort", sport, organizationId, seasonId],
    queryFn: async () => {
      const response = await request<RosterShortResponse>(url);
      return response.data ?? [];
    },
    enabled: !!seasonId,
  });
};

export default useFetchSeasonRosterShort;
